
import {getLastOperation} from '../api/getLastOperation';
import {setGetLastOperationAction} from '../action';

const setGetLastOperation = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getLastOperation(params);

            if (data.status === 'success') {
                dispatch(setGetLastOperationAction({
                    data: data.data,
                    count: data.count,
                    allPage: data.allPage
                }));           
            }
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetLastOperation
}